module.exports = __webpack_public_path__ + "media/application/images/svgs/users-8dcbb50ba21551faa8e23524053a3318.svg";